import React, {useEffect, useState} from 'react'
import SignupFormMob from '../SignupFormMob'

function DemoModalV2({open, onClose}) {
  const [videoStarted, setVideoStarted] = useState(false)

  useEffect(() => {
    if (!open) return undefined
    document.body.style.overflow = 'hidden'
    const onKey = event => {
      if (event.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', onKey)
    return () => {
      document.body.style.overflow = ''
      window.removeEventListener('keydown', onKey)
    }
  }, [open, onClose])

  useEffect(() => {
    if (!open) setVideoStarted(false)
  }, [open])

  if (!open) return null

  const startVideo = event => {
    event.preventDefault()
    event.stopPropagation()
    setVideoStarted(true)
  }

  return (
    <div className="hlm-modal-backdrop hlm-demo-modal-backdrop" role="presentation" onClick={onClose}>
      <div className="hlm-modal hlm-demo-modal" role="dialog" aria-modal="true" aria-labelledby="demo-title" onClick={event => event.stopPropagation()}>
        <button className="hlm-modal-close" aria-label="Close" onClick={onClose}>
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true">
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </button>
        <div className="hlm-demo-card-inner">
          {videoStarted ? (
            <div className="hlm-demo-video hlm-demo-video-playing">
              <iframe
                src="https://player.vimeo.com/video/347112369?autoplay=1&title=0&byline=0&portrait=0"
                title="Introduction Demo"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              />
            </div>
          ) : (
            <button type="button" className="hlm-demo-video" aria-label="Play demo video" onClick={startVideo}>
              <span className="hlm-demo-video-glow" aria-hidden="true" />
              <span className="hlm-demo-video-grid" aria-hidden="true" />
              <span className="hlm-demo-video-copy">
                <span className="hlm-demo-video-pill">
                  <span aria-hidden="true" />
                  HOW IT WORKS
                </span>
                <span className="hlm-demo-video-title">See HomeLight Listing Management in action.</span>
              </span>
              <span className="hlm-demo-play" aria-hidden="true">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round">
                  <path d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z" />
                </svg>
              </span>
              <span className="hlm-demo-video-progress" aria-hidden="true">
                <span />
              </span>
            </button>
          )}

          <h2 id="demo-title" className="hlm-modal-title">
            Watch the demo, then <span className="hlm-modal-title-highlight">start your free trial.</span>
          </h2>
          <p className="hlm-modal-sub">Enter your email to sign up and start running listings on HomeLight.</p>

          <div className="hlm-demo-signup">
            <label className="hlm-signup-modal-label" htmlFor="hlm-demo-email">
              Work email
            </label>
            <SignupFormMob size="md" className="hlm-demo-signup-form" inputId="hlm-demo-email" buttonText="Sign up for free" />
          </div>

          <div className="hlm-demo-trust" aria-label="Signup benefits">
            {['14-day free trial', 'No credit card', 'Cancel anytime'].map(item => (
              <span key={item}>
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true">
                  <path d="M20 6 9 17l-5-5" />
                </svg>
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default DemoModalV2
